// TODO: add different environments (qa, prod...)
export enum ExternalRoutes {
    Www = 'https://www.carmax.com',
    Images = 'https://img2.carmax.com/img'
}
